export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.8b396830.worker.js");
}
